import Marionette from 'backbone.marionette';

import {
	StreakTipsLayout,
	AdvertisingView,
	UserInfoRow,
	StreakGamebar,
	WidgetLadder,
	StreakPlaceholderView,
	WidgetStreakTracker,
	WidgetBets,
	// TippingGlobalNotification,
} from '../../views';

import { isMobileView, sizes_for_big_ad } from '../../../../core/utils';
import { CompShareModel, GauntletModel, Tipping as GameBarModel, User } from "../../models";
import { Ladder, Rounds, Squads, Tipping, Venues } from "../../collections";
import { Model } from "backbone";

export class StreakController extends Marionette.Object {
	/**
	 * Streak page ( /streak )
	 */
	streak() {
		const
			pageLayout = new StreakTipsLayout({
				rounds: new Rounds(),
				squads: new Squads(),
				venues: new Venues(),
				collection: new Tipping(),
				gauntlet: new GauntletModel()
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'streak-ad-slot-2',
				ad_path: 'streak',
				size: sizes_for_big_ad(),
				pos: 3,
			});

		pageLayout.on('access:denied', () => {
			this.getOption('rootView')
				.getRegion('main')
				.show(new StreakPlaceholderView());
		});

		pageLayout.getRegion('gamebar').show(new StreakGamebar());

		pageLayout.getRegion('user_info').show(new UserInfoRow({
			share: new CompShareModel({
				team_share: true
			}),
			model: new GameBarModel()
		}));

		pageLayout.getRegion('widget_1').show(new WidgetStreakTracker({
			model: new Model(),
		}));

		if( isMobileView() && User.is_adult ) {
			pageLayout.getRegion('widget_1').show(new WidgetBets());
		}

		pageLayout.getRegion('widget_2').show(new WidgetLadder({
			model: new Model(),
			collection: new Ladder()
		}));

		// this.getOption('rootView').getRegion('global_notification')
		// 	.show(new TippingGlobalNotification());

		this.getOption('rootView').getRegion('main').show(pageLayout);
		this.getOption('rootView').getRegion('top_ads_container').show(advertisingFooter);

	}
}

export default StreakController;